import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './score.types';
import * as constants from './score.constants';

export const scoreReducer = generateResourceReducer<types.IScore>({
  STORE: constants.STORE_SCORE,
  CLEAR: constants.CLEAR_SCORE,
});
